import AssertionError from 'shared/errors/AssertionError'

const assert = (condition, message, ...codes) => {
  if (!condition) {
    throw new AssertionError(message || 'Assertion failed', ...codes)
  }
}

export default assert
